import * as types from "../types";
import { GETTER_ADVISOR_ACCOUNTS } from "./types";

export default {
    [types.FUND_GETTER_WITHDRAW_MODAL_OPEN]: (state) => {
        return state.withdrawModalOpen
    },
    [types.FUND_GETTER_DEPOSIT_MODAL_OPEN]: (state) => {
        return state.depositModalOpen
    },
    [types.FUND_GETTER_PENDING_DEPOSIT_ATTRIBUTIONS]: (state) => {
        return state.pendingDepositAttributions
    },
    [types.FUND_GETTER_CLIENT_TRADING_ACCOUNTS]: (state) => {
        return state.clientTradingAccounts
    },
    [GETTER_ADVISOR_ACCOUNTS]: (state) => {
        return state.advisorAccounts;
    },
}